import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { GridParams } from "common/models/utility-models/list-utility.model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class CompanyGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
      super(
        'Company',
        ROUTE_PATH.internshipComapny,
        ROUTE_PATH.internshipCompanyForm,
        true,
        true,
        8,
        true,
        true,
        ['companyName'],
        false,
        [],
        {
          isDownloadExcel: true,
          excelFileName:
            'InternshipCompany' + new Date().toLocaleDateString() + '.xlsx',
          btnLabel: 'Download List',
          headers: [
            { key: 'internship_company', value: 'companyName' },
            { key: 'location', value: 'totalLocation' },
            { key: 'mentors', value: 'totalMentor' },
            { key: 'interns', value: 'totalIntern' },
          ],
        },
        false,
        { evalKey: 'isDeletable', evalParam: ['0'], decisiveParam: false },
        false,
        false,
        false,
        null,
        { evalKey: 'isDeletable', evalParam: ['0'], decisiveParam: false },
        false,
        null,
        {
          isPreview: false,
          isPreviewType: 'VIDEO',
          isEnvUrl: false,
          linkKey: ['filePath'],
          previewName: '',
        },
        {
          isTabSwitch: false,
          label: '',
          isChecked: false,
        },
        true,
        true,
        true,
        [],
        false,
        {
          isExtraActions: true,
          btnLabel: '',
          selectOptions: [
            { key: 2024, value: 2024 },
            { key: 2023, value: 2023 },
            { key: 2022, value: 2022 },
          ],
          selectedValue: new Date().getFullYear().toString(),
        },
        {
          isCheckboxEmit: true,
          emitKey: 'id',
          checkedKey: '',
          valueKey: '',
        },
        { isDownload: false, key: '', valueKey: '' },
        { isTabStatus: false, label: '', isChecked: false },
        true,
        true,
        {
          isPrimary: false,
          isDanger: true,
        },
        'Companies',
        {
          value:'',
          isVisible:true
        },
        true,
        true,
        false,
      );
    }
  
    prepareHeaderList(): Headers[] {
      const headers: Headers[] = [];
      const internship_company = new Headers(
        'Internship Company',
        'companyName',
        true,
        true,
        'text'
      );
      const location = new Headers(
        'Location',
        'totalLocation',
        true,
        true,
        'text',
        '0',
        {
          isColumnNavigation: true,
          navigationUrl: ROUTE_PATH.internshipCompanyLocation,
          navigateOperationType: OperationType.VIEW,
          navigateTransferData: new GridParams(),
          navigatePageName: 'Location List',
        }
      );
      const mentors = new Headers(
        'Mentors',
        'totalMentor',
        true,
        true,
        'text',
        '0',
        {
          isColumnNavigation: true,
          navigationUrl: ROUTE_PATH.internshipCompanyMentor,
          navigateOperationType: OperationType.VIEW,
          navigateTransferData: new GridParams(),
          navigatePageName: 'Mentor List',
        }
      );
      const interns = new Headers(
        'Intern required',
        'totalIntern',
        true,
        true,
        'text'
      );
  
      headers.push(internship_company);
      headers.push(location);
      headers.push(mentors);
      headers.push(interns);
  
      return headers;
    }
  }
  